module.exports = __webpack_public_path__ + "fonts/Oswald-500-vietnamese13.e796e52.woff2";